<ng-container>
    <mat-list class="st-staff-id-list-tooltip-content">
        <mat-list-item *ngFor="let user of users">
            <st-avatar
                big
                class="st-staff-id-list-tooltip-avatar"
                [userId]="user.UserID" />
            <div class="st-staff-id-list-tooltip-info">
                <div class="st-staff-id-list-tooltip-info__user">
                    <span class="st-staff-id-list-tooltip-info__user-name"> {{ user.GivenName + ' ' + user.Surname }} </span>
                    <span *ngIf="user.Email"
                        ><a
                            class="st-staff-id-list-tooltip-info__user-email"
                            [href]="'mailto:' + user.Email"
                            >{{ user.Email }}</a
                        >
                    </span>
                </div>
                <span *ngIf="user.Title"> {{ user.Title }} </span>
                <span *ngIf="user.Phone"> {{ user.Phone }} </span>
            </div>
        </mat-list-item>
    </mat-list>
</ng-container>
